import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type TranslationOptions = Record<string, unknown>;

const buildI18nOptions = (defaultValue: string | undefined, options: TranslationOptions = {}) => {
  const next = { ...options };
  if (defaultValue !== undefined) {
    (next as Record<string, unknown>).defaultValue = defaultValue;
  }
  return next;
};

export const useAppTranslation = () => {
  const { t, i18n } = useTranslation();

  const translateKey = useCallback(
    (key: string, defaultValue?: string, options: TranslationOptions = {}): string =>
      t(key, buildI18nOptions(defaultValue, options)) as string,
    [t]
  );

  return { t: translateKey, i18n };
};
